import React from "react";
import PropTypes from "prop-types";

export default function Tick2(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.48578 0 0 4.48578 0 10C0 15.5142 4.48578 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48578 15.5142 0 10 0ZM15.0684 7.88086L9.65164 13.2974C9.48914 13.4599 9.27582 13.5417 9.0625 13.5417C8.84918 13.5417 8.63586 13.4599 8.47336 13.2974L5.76508 10.5891C5.43915 10.2634 5.43915 9.73663 5.76508 9.41086C6.09085 9.08493 6.61743 9.08493 6.94336 9.41086L9.0625 11.53L13.8901 6.70258C14.2159 6.37665 14.7424 6.37665 15.0684 6.70258C15.3941 7.02835 15.3941 7.55493 15.0684 7.88086Z"
        fill="#44934C"
      />
    </svg>
  );
}

Tick2.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

Tick2.defaultProps = {
  className: "",
  width: 20,
  height: 20
};
